/*
 * Application Insights JavaScript SDK - Properties Plugin, 3.0.0
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


var Location = /** @class */ (function () {
    function Location() {
    }
    return Location;
}());
export { Location };
//# sourceMappingURL=Location.js.map